import { render, staticRenderFns } from "./habitDialog.vue?vue&type=template&id=5467812f&scoped=true"
import script from "./habitDialog.vue?vue&type=script&lang=js"
export * from "./habitDialog.vue?vue&type=script&lang=js"
import style0 from "./habitDialog.vue?vue&type=style&index=0&id=5467812f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5467812f",
  null
  
)

export default component.exports